module.exports = __webpack_public_path__ + "img/15.bc39d591.jpg";